import type { ComponentProps } from "react";
import { FieldGroup } from "@/shared/components/ui/FieldGroup";
import { Section } from "@/shared/components/ui/Section";
import { ProfileFields } from "./ProfileFields";

export function ProfileSection(props: ComponentProps<typeof ProfileFields>) {
  return (
    <Section title="Personal details">
      <FieldGroup>
        <p className="text-sm text-muted-foreground">A little about you.</p>
        <ProfileFields {...props} />
      </FieldGroup>
    </Section>
  );
}